import { __awaiter, __generator } from "tslib";
import { failure, isFailure, isSuccess, isSuccessAll, success, isFailureAny, isLoadingAny, loading, notAsked, } from '../libs/remoteData';
import { axiosInstance } from './instance';
export function service(config) {
    return __awaiter(this, void 0, void 0, function () {
        var response, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axiosInstance(config)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, success(response.data)];
                case 2:
                    err_1 = _a.sent();
                    return [2 /*return*/, failure(err_1.response ? err_1.response.data : err_1.message)];
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function applyDataTransformer(servicePromise, transformer) {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, servicePromise];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, mapSuccess(response, transformer)];
            }
        });
    });
}
export function applyErrorTransformer(servicePromise, transformer) {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, servicePromise];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, mapFailure(response, transformer)];
            }
        });
    });
}
export function mapSuccess(remoteData, transformer) {
    if (isSuccess(remoteData)) {
        return success(transformer(remoteData.data));
    }
    return remoteData;
}
export function mapFailure(remoteData, transformer) {
    if (isFailure(remoteData)) {
        return failure(transformer(remoteData.error));
    }
    return remoteData;
}
function createKeysMapTransformer(keys) {
    return function (data) {
        return keys.reduce(function (transformed, key, index) {
            transformed[key] = data[index];
            return transformed;
        }, {});
    };
}
export function sequenceArray(remoteDataArray) {
    if (isSuccessAll(remoteDataArray)) {
        return success(remoteDataArray.map(function (remoteDataResult) { return remoteDataResult.data; }));
    }
    if (isFailureAny(remoteDataArray)) {
        return failure(remoteDataArray.reduce(function (accumulator, remoteDataResult) {
            if (isFailure(remoteDataResult)) {
                accumulator.push(remoteDataResult.error);
            }
            return accumulator;
        }, []));
    }
    if (isLoadingAny(remoteDataArray)) {
        return loading;
    }
    return notAsked;
}
export function sequenceMap(remoteDataMap) {
    var keys = Object.keys(remoteDataMap);
    var remoteDataArray = Object.values(remoteDataMap);
    return mapSuccess(sequenceArray(remoteDataArray), createKeysMapTransformer(keys));
}
export function resolveArray(promiseArray) {
    return __awaiter(this, void 0, void 0, function () {
        var remoteDataResults;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all(promiseArray)];
                case 1:
                    remoteDataResults = (_a.sent());
                    return [2 /*return*/, sequenceArray(remoteDataResults)];
            }
        });
    });
}
export function resolveMap(promiseMap) {
    return __awaiter(this, void 0, void 0, function () {
        var keys, remoteDataResults, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    keys = Object.keys(promiseMap);
                    return [4 /*yield*/, Promise.all(Object.values(promiseMap))];
                case 1:
                    remoteDataResults = (_a.sent());
                    result = mapSuccess(sequenceArray(remoteDataResults), createKeysMapTransformer(keys));
                    return [2 /*return*/, Promise.resolve(result)];
            }
        });
    });
}
export function resolveServiceMap(promiseMap) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, resolveMap(promiseMap)];
        });
    });
}
//# sourceMappingURL=service.js.map